module.exports = __webpack_public_path__ + "img/muted_icon.9506fded.svg";